var map = {
	"./bahrain_flag.svg": 133948,
	"./egypt_flag.svg": 808559,
	"./jordan_flag.svg": 414848,
	"./ksa_flag.svg": 864296,
	"./kuwait_flag.svg": 254804,
	"./oman_flag.svg": 865588,
	"./qatar_flag.svg": 21824,
	"./uae_flag.svg": 131324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 586596;